export default __webpack_public_path__ + "static/media/closet4-2048w.f6b76b28.avif";